import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Copy, KeyRound, Link2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { prettyDate } from "@/lib/geo";

const btn = "px-3 py-1.5 rounded-full text-xs transition-colors";

export const AtlasCard = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["atlas"], queryFn: api.atlasStatus });
  const [key, setKey] = useState("");
  const create = async () => {
    if (data?.connected && !window.confirm("Make a new key? The old key will stop working.")) return;
    try { setKey(await api.atlasCreateKey()); } catch { toast.error("Could not create a key — try again"); }
    qc.invalidateQueries({ queryKey: ["atlas"] });
  };
  const revoke = async () => {
    if (!window.confirm("Revoke the key? ATLAS will no longer be able to add contacts.")) return;
    try { await api.atlasRevokeKey(); } catch { return toast.error("Could not revoke the key — try again"); }
    setKey("");
    qc.invalidateQueries({ queryKey: ["atlas"] });
    toast.success("ATLAS key revoked");
  };
  const copy = () => navigator.clipboard.writeText(key).then(() => toast.success("Key copied"), () => toast.error("Couldn't copy — select the key and copy it by hand"));
  return (
    <section className="rounded-xl border border-white/10 bg-white/[0.03] p-4" data-testid="atlas-card">
      <div className="flex items-center gap-2"><Link2 size={16} className="text-sky-300" /><h3 className="font-display font-semibold">ATLAS connection</h3></div>
      <p className="text-xs text-slate-400 mt-1.5">Lets your ATLAS app add contacts to your Want to go list. Keep the key private.</p>
      <p className="text-xs mt-3" data-testid="atlas-status">
        {data?.connected ? <span className="text-emerald-300">Connected · key made {prettyDate(data.created_at.slice(0, 10), "d MMM yyyy")}</span> : <span className="text-slate-500">Not connected</span>}
      </p>
      {key && (
        <div className="mt-3 rounded-lg border border-amber-400/30 bg-amber-400/5 p-3" data-testid="atlas-new-key">
          <p className="text-[11px] text-amber-200">Copy this key into ATLAS now — it won't be shown again.</p>
          <div className="flex gap-2 mt-2 items-center">
            <code className="flex-1 text-[11px] break-all font-mono text-slate-100" data-testid="atlas-key-value">{key}</code>
            <button onClick={copy} className={`${btn} bg-white text-[#0B0F17] flex items-center gap-1`} data-testid="atlas-copy-key"><Copy size={12} /> Copy</button>
          </div>
        </div>
      )}
      <div className="flex gap-2 mt-4">
        <button onClick={create} className={`${btn} bg-sky-400 text-[#0B0F17] hover:bg-sky-300 flex items-center gap-1`} data-testid="atlas-create-key"><KeyRound size={12} /> {data?.connected ? "Make a new key" : "Create key"}</button>
        {data?.connected && <button onClick={revoke} className={`${btn} border border-red-400/40 text-red-300 hover:bg-red-400/10`} data-testid="atlas-revoke-key">Revoke key</button>}
      </div>
    </section>
  );
};
